import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ValueHelperService {
  public filterValue: string = 'ALL_TIME';
  private history = [];
  public date: any = {
    startDate: moment(),
    endDate: moment()
  };
  constructor(private router: Router) { }

  setSelectedFilter(filterValue) {
    this.filterValue = filterValue;
  }

  getFilterValue() {
    return this.filterValue;
  }

  setDate(date) {
    this.date = date;
  }

  getDate() {
    return this.date;
  }

  routeBasedOnParams(routeParams) {
    if (routeParams === 'all') {
      this.router.navigate(['/dashboard/business-ledger/all-transaction']);
    } else if (routeParams === 'r') {
      this.router.navigate(['/dashboard/business-ledger/receivables']);
    } else if (routeParams === 'p') {
      this.router.navigate(['/dashboard/business-ledger/payable']);
    }
  }

  startFormatDate(date) {
    const formattedDate = moment(date).set({ hour: 0, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss');
    return formattedDate;
  }

  endFormatDate(date) {
    const formattedDate = moment(date).set({ hour: 23, minute: 59, second: 59 }).format('YYYY-MM-DDTHH:mm:ss');
    return formattedDate;
  }

  public loadRouting(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
        this.history = [...this.history, urlAfterRedirects];
      });
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || '/index';
  }

  public getPreviousUrlFor404(): string {
    return this.history[this.history.length - 1] || '/index';
  }
}
